/** Copy for partners page — merged into `translations` as `partners`. */

export const partnersEs = {
  seo: {
    title: 'Chisme para negocios | Trae clientas listas para quedar',
    description:
      'Trae clientas listas para quedar a tu negocio cuando crean planes en cafés, pilates o gimnasio. Más de 100.000 usuarias en España, Estados Unidos y Latinoamérica.',
  },
  nav: {
    logoAria: 'Chisme',
    ctaShort: 'Registrar',
    ctaLong: 'Registrar mi negocio',
  },
  cta: {
    registerBusiness: 'Registrar mi negocio',
    howItWorks: 'Cómo funciona',
  },
  hero: {
    badge: ['Más clientas', 'Visibilidad local', 'Sin permanencia'] as const,
    h1Line1: 'Trae clientas listas',
    h1Line2: 'para quedar',
    h1Accent: 'a tu negocio',
    subtitle:
      'Cuando crean planes en cafés, pilates o gimnasio, tu negocio aparece en el momento exacto en que deciden. Más de 100.000 usuarias en España, Estados Unidos y Latinoamérica.',
    mockupAlt: 'Planes activos en la app de Chisme con participantes apuntadas',
  },
  stats: [
    { value: '100.000+', label: 'usuarias en la app', sub: '' },
    { value: '7.000+', label: 'usuarias activas', sub: 'en las ciudades grandes' },
    { value: '15+', label: 'planes cada día', sub: 'en las ciudades grandes' },
  ] as const,
  contrast: {
    titleLine1: 'Google / Meta',
    titleLine2: 'vs Chisme',
    subtitle: 'Apareces cuando ya están decidiendo dónde ir.',
    competitorLabel: 'Google / Meta',
  },
  comparisonRows: [
    {
      label: 'Momento',
      google: 'La usuaria está scrolleando sin intención',
      chisme: 'Está eligiendo dónde quedar ahora mismo',
    },
    {
      label: 'Sensación',
      google: 'Interrumpe lo que estaba haciendo',
      chisme: 'Recomendación natural en el momento del plan',
    },
    {
      label: 'Métricas',
      google: 'Clics e impresiones, difícil saber si vinieron',
      chisme: 'Planes creados en tu local y participantes reales',
    },
    {
      label: 'Compromiso',
      google: 'Sin límite de competencia',
      chisme: 'Pocas plazas por ciudad: no compites con cientos',
    },
    {
      label: 'Cancelación',
      google: 'Cualquier momento',
      chisme: 'Cualquier momento, sin permanencia',
    },
  ] as const,
  howItWorks: {
    titleLine1: 'Cómo',
    titleLine2: 'funciona',
    subtitle: 'Tu negocio en el mapa de Chisme en unos minutos, sin llamadas ni emails.',
    steps: [
      {
        title: 'Encuentra tu negocio',
        description: 'Búscalo en Google Maps y rellenamos los datos por ti.',
      },
      {
        title: 'Completa tu ficha',
        description: 'Fotos, servicios, descuento para Chisme y tu enlace de reservas.',
      },
      {
        title: 'Paga y queda tu plaza',
        description: 'Ves el precio antes de pagar en Stripe. Hay pocas plazas por ciudad.',
      },
      {
        title: 'Empieza a aparecer',
        description: 'La revisamos en menos de 24 h y sale en el mapa a las chicas cerca de ti.',
      },
    ] as const,
  },
  features: {
    titleLine1: 'Qué obtienes',
    titleLine2: 'como socio',
    subtitle: 'Cafeterías, estudios, gimnasios: todo lo que necesitas para que te elijan en Chisme.',
    items: [
      {
        icon: 'profile' as const,
        title: 'Perfil destacado',
        description:
          'Fotos, descripción, horarios y enlace directo a tu negocio. Tu local, bien presentado.',
      },
      {
        icon: 'map' as const,
        title: 'Mapa de la app',
        description:
          'Apareces en el mapa de Chisme, resaltado por encima de locales que no son socios.',
      },
      {
        icon: 'recommend' as const,
        title: 'Recomendación al crear planes',
        description:
          'Cuando alguien crea un plan (café, brunch, pilates, yoga o lo que sea), te sugerimos como opción.',
      },
      {
        icon: 'exclusivity' as const,
        title: 'Pocas plazas por ciudad',
        description:
          'Aceptamos pocos negocios por ciudad para que el tuyo se vea en el mapa.',
      },
    ] as const,
    analytics: {
      title: 'Panel de analíticas',
      subtitle:
        'Mide lo que importa, no los clics. Datos reales de uso en tu panel de socio, sin adivinar si funcionó.',
      metrics: [
        {
          title: 'Planes creados',
          description: 'Cuántos planes se han hecho en tu local cada mes.',
        },
        {
          title: 'Participantes estimados',
          description: 'Mujeres que se unen a esos planes, no clics vacíos.',
        },
        {
          title: 'Vistas del perfil y mapa',
          description: 'Cuántas veces te han visto al buscar o crear un plan.',
        },
        {
          title: 'Clics en web e Instagram',
          description: 'Cuántas usuarias han pulsado el enlace a tu web o Instagram desde tu ficha.',
        },
        {
          title: 'Día y franja horaria',
          description: 'Cuándo tienes más actividad, para ajustar horarios o promos.',
        },
        {
          title: 'Tendencias históricas',
          description: 'Evolución mes a mes para ver si crece tu visibilidad.',
        },
      ] as const,
    },
  },
  exclusivity: {
    titleLine1: 'Plazas limitadas,',
    titleLine2: 'no marketing',
    subtitle:
      'Aceptamos un número limitado de negocios y de eventos en cada ciudad, para que todos se vean.',
    categories: [
      'Cafeterías y restaurantes',
      'Estudios de pilates y yoga',
      'Gimnasios y centros de bienestar',
      'Brunch, wine bars y más',
    ] as const,
    points: [
      {
        title: 'Plazas por ciudad',
        description:
          'Al registrarte ves cuántas plazas quedan en tu ciudad. Si está completa, te apuntas a la lista de espera.',
      },
      {
        title: 'Visibilidad relevante',
        description:
          'Presentamos tu negocio de forma relevante cuando las usuarias buscan dónde quedar.',
      },
      {
        title: 'Disponibilidad por barrio',
        description:
          'Aceptamos pocos negocios por ciudad para que todos se vean. Al registrarte ves cuántas plazas quedan en la tuya.',
      },
    ] as const,
    footnote: 'Comprueba cuántas plazas quedan en tu ciudad al registrarte.',
  },
  faq: {
    titleLine1: 'Preguntas',
    titleLine2: 'frecuentes',
    subtitle: 'Lo que nos preguntan los dueños de locales antes de unirse.',
    items: [
      {
        question: '¿Qué es Chisme exactamente?',
        answer:
          'Chisme es una app donde mujeres de España, Estados Unidos y Latinoamérica crean planes para quedar en persona: cafés, brunch, pilates, yoga, paseos y más. Más de 100.000 usuarias usan la app, con más de 7.000 activas y al menos 15 planes nuevos cada día en las ciudades grandes. No es una red social: es para pasar de hablar a quedar de verdad.',
      },
      {
        question: '¿Qué tipo de negocios pueden ser socios?',
        answer:
          'Cafeterías, restaurantes, brunch spots, wine bars, estudios de pilates y yoga, gimnasios y centros de bienestar. Si tu local es un sitio donde las mujeres de Chisme quieren quedar, encaja.',
      },
      {
        question: '¿Cómo me ven las usuarias?',
        answer:
          'Cuando una usuaria abre el mapa de la app o crea un plan (un café, una clase de pilates, brunch, lo que sea), tu local aparece como recomendación si encaja con el barrio y la categoría. No es un anuncio que interrumpe: es una sugerencia en el momento en que están decidiendo dónde ir.',
      },
      {
        question: '¿Hay plazas limitadas por ciudad?',
        answer:
          'Aceptamos un número limitado de negocios y de eventos por ciudad. Al registrarte ves cuántas plazas quedan; si está completa, puedes apuntarte a la lista de espera.',
      },
      {
        question: '¿Hay permanencia o contrato?',
        answer:
          'No hay compromiso a largo plazo. Puedes dejar de participar cuando quieras.',
      },
      {
        question: '¿Qué incluye el panel de analíticas?',
        answer:
          'Ves cuántos planes se han creado en tu local, participantes estimados, vistas de tu perfil y del mapa, clics en tu web e Instagram, desglose por día de la semana y franja horaria, y tendencias a lo largo del tiempo. Datos reales de uso, no clics vacíos.',
      },
      {
        question: '¿Cómo empiezo?',
        answer:
          'Registra tu negocio en business.chisme.social: búscalo en Google Maps, revisa el precio y paga en Stripe. Lo revisamos en menos de 24 h y, si encaja, lo publicamos en el mapa.',
      },
    ] as const,
  },
  finalCta: {
    titleLine1: '¿Listo para',
    titleLine2: 'empezar?',
    subtitle:
      'Registra tu negocio en unos minutos. Lo revisamos en menos de 24 h y lo publicamos en el mapa.',
    footnote: 'En todas las ciudades · ¿Dudas?',
  },
} as const;

export const partnersEn = {
  seo: {
    title: 'Chisme for businesses | Bring customers ready to meet',
    description:
      'Bring customers ready to visit your business when they plan coffee, pilates or gym meetups. 100,000+ users across Spain, the US and Latin America.',
  },
  nav: {
    logoAria: 'Chisme',
    ctaShort: 'Register',
    ctaLong: 'Register my business',
  },
  cta: {
    registerBusiness: 'Register my business',
    howItWorks: 'How it works',
  },
  hero: {
    badge: ['More customers', 'Local visibility', 'No commitment'] as const,
    h1Line1: 'Bring customers ready',
    h1Line2: 'to meet',
    h1Accent: 'at your business',
    subtitle:
      'When they plan coffee, pilates or gym meetups, your business appears at the exact moment they decide. 100,000+ users across Spain, the US and Latin America.',
    mockupAlt: 'Active plans in the Chisme app with signed-up participants',
  },
  stats: [
    { value: '100,000+', label: 'users on the app', sub: '' },
    { value: '7,000+', label: 'active users', sub: 'in the biggest cities' },
    { value: '15+', label: 'plans every day', sub: 'in the biggest cities' },
  ] as const,
  contrast: {
    titleLine1: 'Google / Meta',
    titleLine2: 'vs Chisme',
    subtitle: "You appear when they're already deciding where to go.",
    competitorLabel: 'Google / Meta',
  },
  comparisonRows: [
    {
      label: 'Timing',
      google: "The user is scrolling without intent",
      chisme: "She's choosing where to meet right now",
    },
    {
      label: 'Feel',
      google: 'Interrupts what she was doing',
      chisme: 'Natural recommendation at plan time',
    },
    {
      label: 'Metrics',
      google: 'Clicks and impressions — hard to know if they came',
      chisme: 'Plans created at your venue and real participants',
    },
    {
      label: 'Competition',
      google: 'No limit on competitors',
      chisme: 'Few spots per city: you don’t compete with hundreds',
    },
    {
      label: 'Cancellation',
      google: 'Any time',
      chisme: 'Any time, no lock-in',
    },
  ] as const,
  howItWorks: {
    titleLine1: 'How it',
    titleLine2: 'works',
    subtitle: 'Your business on the Chisme map in a few minutes — no calls or emails.',
    steps: [
      {
        title: 'Find your business',
        description: 'Search for it on Google Maps and we fill in the details for you.',
      },
      {
        title: 'Complete your listing',
        description: 'Photos, services, a Chisme discount and your booking link.',
      },
      {
        title: 'Pay and secure your spot',
        description: 'See the price before paying with Stripe. Spots per city are limited.',
      },
      {
        title: 'Start appearing',
        description: 'We review it within 24 hours and show it on the map to women nearby.',
      },
    ] as const,
  },
  features: {
    titleLine1: 'What you get',
    titleLine2: 'as a partner',
    subtitle: 'Cafés, studios, gyms: everything you need to get chosen on Chisme.',
    items: [
      {
        icon: 'profile' as const,
        title: 'Featured profile',
        description:
          'Photos, description, hours and a direct link to your business. Your venue, presented well.',
      },
      {
        icon: 'map' as const,
        title: 'In-app map',
        description:
          'You appear on the Chisme map, highlighted above venues that are not partners.',
      },
      {
        icon: 'recommend' as const,
        title: 'Recommended when plans are created',
        description:
          'When someone creates a plan (coffee, brunch, pilates, yoga or whatever), we suggest you as an option.',
      },
      {
        icon: 'exclusivity' as const,
        title: 'Few spots per city',
        description:
          'We accept few businesses per city so yours stands out on the map.',
      },
    ] as const,
    analytics: {
      title: 'Analytics dashboard',
      subtitle:
        'Measure what matters, not clicks. Real usage data in your partner dashboard — no guessing if it worked.',
      metrics: [
        {
          title: 'Plans created',
          description: 'How many plans were made at your venue each month.',
        },
        {
          title: 'Estimated participants',
          description: 'Women joining those plans — not empty clicks.',
        },
        {
          title: 'Profile and map views',
          description: 'How many times you were seen when searching or creating a plan.',
        },
        {
          title: 'Website and Instagram clicks',
          description: 'How many users tapped your website or Instagram link from your listing.',
        },
        {
          title: 'Day and time slot',
          description: 'When you get the most activity, to adjust hours or promos.',
        },
        {
          title: 'Historical trends',
          description: 'Month-over-month evolution to see if your visibility is growing.',
        },
      ] as const,
    },
  },
  exclusivity: {
    titleLine1: 'Limited spots,',
    titleLine2: 'not marketing',
    subtitle:
      'We accept a limited number of businesses and events in each city, so every one is seen.',
    categories: [
      'Cafés and restaurants',
      'Pilates and yoga studios',
      'Gyms and wellness centres',
      'Brunch, wine bars and more',
    ] as const,
    points: [
      {
        title: 'Local options',
        description:
          'When you register you see how many spots are left in your city. If it is full, you join the waiting list.',
      },
      {
        title: 'Relevant visibility',
        description:
          'We present your business when users are actively choosing where to meet.',
      },
      {
        title: 'Neighbourhood availability',
        description:
          'We accept few businesses per city so every one is seen. When you register you see how many spots are left in yours.',
      },
    ] as const,
    footnote: 'See how many spots are left in your city when you register.',
  },
  faq: {
    titleLine1: 'Frequently',
    titleLine2: 'asked questions',
    subtitle: 'What venue owners ask us before joining.',
    items: [
      {
        question: 'What exactly is Chisme?',
        answer:
          'Chisme is an app where women across Spain, the US and Latin America create plans to meet in person: coffee, brunch, pilates, yoga, walks and more. Over 100,000 users are on the app, with 7,000+ active and at least 15 new plans every day in the biggest cities. It is not a social network — it is for going from chatting to actually meeting.',
      },
      {
        question: 'What types of businesses can be partners?',
        answer:
          'Cafés, restaurants, brunch spots, wine bars, pilates and yoga studios, gyms and wellness centres. If your venue is somewhere Chisme women want to meet, it fits.',
      },
      {
        question: 'How do users see me?',
        answer:
          'When a user opens the app map or creates a plan (coffee, a pilates class, brunch, whatever), your venue appears as a recommendation if it matches the neighbourhood and category. It is not an interrupting ad — it is a suggestion at the moment they are deciding where to go.',
      },
      {
        question: 'Are spots limited per city?',
        answer:
          'We accept a limited number of businesses and events per city. When you register you see how many spots are left; if it is full, you can join the waiting list.',
      },
      {
        question: 'Is there a contract or lock-in?',
        answer:
          'There is no long-term commitment. You can stop participating whenever you want.',
      },
      {
        question: 'What does the analytics dashboard include?',
        answer:
          'You see how many plans were created at your venue, estimated participants, profile and map views, website and Instagram clicks, breakdown by day of week and time slot, and trends over time. Real usage data — not empty clicks.',
      },
      {
        question: 'How do I get started?',
        answer:
          'Register your business at business.chisme.social: find it on Google Maps, check the price and pay with Stripe. We review it within 24 hours and, if it fits, publish it on the map.',
      },
    ] as const,
  },
  finalCta: {
    titleLine1: 'Ready to',
    titleLine2: 'get started?',
    subtitle:
      'Register your business in a few minutes. We review it within 24 hours and publish it on the map.',
    footnote: 'In every city · Questions?',
  },
} as const;

export type PartnersStrings = typeof partnersEn;
